import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png"; // Added logo import

// Component to display additional registration details in expanded rows
const ExpandedComponent = ({ data }) => {
  return (
    <div style={{ padding: "8px" }}>
      <p style={{ fontSize: "12px" }}>
        <strong>Organization Name:</strong> {data.organizationName || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Center Name:</strong> {data.centerName || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Family Code:</strong> {data.familyCode || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Code:</strong> {data.code || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Attended:</strong> {data.isAttended ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>First Name:</strong> {data.firstName || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Middle Name:</strong> {data.middleName || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Last Name:</strong> {data.lastName || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Arabic Fore Names:</strong> {data.arabicForeNames || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Arabic Middle Name:</strong> {data.arabicMiddleName || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Arabic Sur Name:</strong> {data.arabicSurName || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Gregorian DOB:</strong>{" "}
        {data.greGorianDOB ? data.greGorianDOB.split("T")[0] : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Hijri DOB:</strong> {data.hijriDOB || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Sibling Enrolled:</strong>{" "}
        {data.isSibilingEnrolled ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Nationality:</strong> {data.nationality || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Gender:</strong>{" "}
        {data.gender === 1 ? "Male" : data.gender === 2 ? "Female" : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Iqama Number:</strong> {data.iqamaNumber || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Iqama Expiry Date:</strong>{" "}
        {data.iqamaExpiryDate ? data.iqamaExpiryDate.split("T")[0] : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Passport Country:</strong> {data.passportCountryId || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Passport Expiry Date:</strong>{" "}
        {data.passportExpiryDate
          ? data.passportExpiryDate.split("T")[0]
          : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Passport Number:</strong> {data.passportNumber || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>GCC Expiry Date:</strong>{" "}
        {data.gccExpiryDate ? data.gccExpiryDate.split("T")[0] : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Saudi ID:</strong> {data.saudiId || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Submit:</strong> {data.isSubmit ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Submission Date:</strong>{" "}
        {data.submissionDate ? data.submissionDate.split("T")[0] : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Fluent In English:</strong> {data.fluentInEnglish || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Fluent In Arabic:</strong> {data.fluentInArabic || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Home Language ID:</strong> {data.homeLanguageId || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>User ID:</strong> {data.userId || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Assessment Date:</strong>{" "}
        {data.assessmentDate ? data.assessmentDate.split("T")[0] : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Assessment Slot ID:</strong> {data.assessmentSlotId || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Communication Remarks:</strong>{" "}
        {data.communicationRemarks || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Communicated To Guardian:</strong>{" "}
        {data.isCommunicatedToGuardian ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Center Class ID:</strong> {data.centerClassId || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Interview Taken:</strong>{" "}
        {data.isInterviewTaken ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Interview Remarks:</strong> {data.interviewRemarks || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Interview Scheduled:</strong>{" "}
        {data.isInterviewScheduled ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Interview Date:</strong>{" "}
        {data.interviewDate ? data.interviewDate.split("T")[0] : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Assessment Added:</strong>{" "}
        {data.isAssessmentAdded ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Assessment Marks Added:</strong>{" "}
        {data.isAssessmentMarksAdded ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Accepted:</strong> {data.isAccepted ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Acceptance Remarks:</strong> {data.acceptanceRemarks || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Has Observation:</strong> {data.hasObservation ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Observation Remarks:</strong> {data.observationRemarks || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Should Retake Exam:</strong>{" "}
        {data.shouldRetakeExam ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Retake Exam Remarks:</strong> {data.retakeExamRemarks || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Registration Voucher No:</strong>{" "}
        {data.registrationVoucherNo || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Paid Registration:</strong>{" "}
        {data.isPaidRegistration ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Admission Voucher No:</strong>{" "}
        {data.admissionVoucherNo || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Paid Admission:</strong>{" "}
        {data.isPaidAdmission ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Is Center Submit:</strong> {data.isCenterSubmit ? "Yes" : "No"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Center Submission Date:</strong>{" "}
        {data.centerSubmissionDate
          ? data.centerSubmissionDate.split("T")[0]
          : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Center Updated By:</strong> {data.centerUpdatedBy || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Created On:</strong>{" "}
        {data.createdOn ? data.createdOn.split("T")[0] : "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Created By:</strong> {data.createdBy || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Country Code:</strong> {data.countryCode || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Country Name:</strong> {data.countryName || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Student Image:</strong> {data.studentImage || "N/A"}
      </p>
      <p style={{ fontSize: "12px" }}>
        <strong>Image Path:</strong> {data.imagePath || "N/A"}
      </p>
    </div>
  );
};

function RegistrationReport() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const {
    control,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nationality: { value: "All", label: "All" },
      yearGroup: { value: "all", label: "All" },
    },
  });

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [searchTerm, setSearchTerm] = useState("");
  const [centersData, setCentersData] = useState([]);
  const [yearGroupsData, setYearGroupsData] = useState([]);
  const [registrationsData, setRegistrationsData] = useState([]);
  const [filteredRegistrations, setFilteredRegistrations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const nationalityOptions = [
    { value: "All", label: "All" },
    { value: "Saudi", label: "Saudi" },
    { value: "Non-Saudi", label: "Non-Saudi" },
  ];

  // Fetch centers on mount
  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCentersData(response);
        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
            setCenterId(selectedCenter.id);
            fetchYearGroupsByCenterId(selectedCenter.id);
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
        toast.error("Failed to fetch centers");
      }
    };
    fetchCenters();
  }, []);

  // Fetch year groups by center ID
  const fetchYearGroupsByCenterId = async (centerId) => {
    try {
      if (centerId) {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setYearGroupsData(response);
      } else {
        setYearGroupsData([]);
        setRegistrationsData([]);
        setFilteredRegistrations([]);
      }
    } catch (error) {
      console.error("Error fetching year groups:", error);
      toast.error("Failed to fetch year groups");
    }
  };

  // Fetch year groups when center changes
  useEffect(() => {
    if (centerId) {
      fetchYearGroupsByCenterId(centerId);
    }
  }, [centerId]);

  // Fetch registrations using the POST API
  const fetchRegistrations = async () => {
    const centerId = watch("centerId")?.value;
    const yearGroupValue = watch("yearGroup")?.value;
    const nationality = watch("nationality")?.value;
    const code = searchTerm;

    if (!centerId) {
      setRegistrationsData([]);
      setFilteredRegistrations([]);
      return;
    }

    const body = {
      centerId: centerId,
      code: code || "",
      isSaudi: { All: 0, Saudi: 1, "Non-Saudi": 2 }[nationality] || 0,
    };

    if (yearGroupValue !== "all") {
      body.classId = yearGroupValue;
    }

    try {
      const response = await post(
        "Reports/RegistrationsByCenterClassandRegistartionNoAsync",
        body,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const enrichedData = (response || []).map((registration) => {
        const yearGroup = yearGroupsData.find(
          (yg) => yg.id === registration.centerClassId
        );
        return {
          ...registration,
          className: yearGroup ? yearGroup.name : "N/A",
        };
      });

      setRegistrationsData(enrichedData);

      // Apply client-side filtering for nationality and code
      let filteredData = enrichedData;

      // Filter by nationality
      if (nationality === "Saudi") {
        filteredData = filteredData.filter(
          (reg) => reg.nationality?.toLowerCase() === "saudi arabia"
        );
      } else if (nationality === "Non-Saudi") {
        filteredData = filteredData.filter(
          (reg) => reg.nationality?.toLowerCase() !== "saudi arabia"
        );
      }

      // Filter by code
      if (code) {
        filteredData = filteredData.filter((reg) =>
          reg.code?.toLowerCase().includes(code.toLowerCase())
        );
      }

      setFilteredRegistrations(filteredData);
    } catch (error) {
      console.error("Error fetching registrations:", error);
      toast.error("Failed to fetch registrations");
    }
  };

  useEffect(() => {
    fetchRegistrations();
  }, [
    watch("centerId"),
    watch("yearGroup"),
    watch("nationality"),
    searchTerm,
    yearGroupsData,
  ]);

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      width: "60px",
    },
    {
      name: "Full Name",
      cell: (row) => {
        let imageSrc = "";
        if (!row.studentImage || row.studentImage === "string") {
          imageSrc = `${process.env.PUBLIC_URL}/image/team/avatar-placeholder.jpg`;
        } else {
          imageSrc = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages/${row.imagePath}`;
        }
        return (
          <div className="d-flex align-items-center gap-2">
            <div className="table-listing-image-preview">
              <img src={imageSrc} alt="Image" />
            </div>
            <div>{row.firstName + " " + row.lastName}</div>
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "Year Group",
      selector: (row) => row.className || "N/A",
      sortable: true,
    },
    {
      name: "Date of Birth",
      selector: (row) =>
        row.greGorianDOB ? row.greGorianDOB.split("T")[0] : "N/A",
      sortable: true,
    },
    {
      name: "Nationality",
      selector: (row) => row.nationality || "N/A",
      sortable: true,
    },
  ];

  const exportToExcel = () => {
    const data = filteredRegistrations.map((registration, index) => ({
      "Sr No": (currentPage - 1) * rowsPerPage + index + 1,
      Code: registration.code,
      "Full Name": `${registration.firstName} ${registration.lastName}`,
      "Year Group": registration.className || "N/A",
      "Date of Birth": registration.greGorianDOB
        ? registration.greGorianDOB.split("T")[0]
        : "N/A",
      Nationality: registration.nationality || "N/A",
      "Organization Name": registration.organizationName || "N/A",
      "Family Code": registration.familyCode || "N/A",
      "Is Attended": registration.isAttended ? "Yes" : "No",
      "Middle Name": registration.middleName || "N/A",
      "Arabic Fore Names": registration.arabicForeNames || "N/A",
      "Arabic Middle Name": registration.arabicMiddleName || "N/A",
      "Arabic Sur Name": registration.arabicSurName || "N/A",
      "Hijri DOB": registration.hijriDOB || "N/A",
      "Is Sibling Enrolled": registration.isSibilingEnrolled ? "Yes" : "No",
      Gender: { 1: "Male", 2: "Female" }[registration.gender] || "N/A",
      "Iqama Number": registration.iqamaNumber || "N/A",
      "Iqama Expiry Date": registration.iqamaExpiryDate
        ? registration.iqamaExpiryDate.split("T")[0]
        : "N/A",
      "Passport Country": registration.passportCountryId || "N/A",
      "Passport Expiry Date": registration.passportExpiryDate
        ? registration.passportExpiryDate.split("T")[0]
        : "N/A",
      "Passport Number": registration.passportNumber || "N/A",
      "GCC Expiry Date": registration.gccExpiryDate
        ? registration.gccExpiryDate.split("T")[0]
        : "N/A",
      "Saudi ID": registration.saudiId || "N/A",
      "Is Submit": registration.isSubmit ? "Yes" : "No",
      "Submission Date": registration.submissionDate
        ? registration.submissionDate.split("T")[0]
        : "N/A",
      "Fluent In English": registration.fluentInEnglish || "N/A",
      "Fluent In Arabic": registration.fluentInArabic || "N/A",
      "Home Language ID": registration.homeLanguageId || "N/A",
      "User ID": registration.userId || "N/A",
      "Assessment Date": registration.assessmentDate
        ? registration.assessmentDate.split("T")[0]
        : "N/A",
      "Assessment Slot ID": registration.assessmentSlotId || "N/A",
      "Communication Remarks": registration.communicationRemarks || "N/A",
      "Is Communicated To Guardian": registration.isCommunicatedToGuardian
        ? "Yes"
        : "No",
      "Center Class ID": registration.centerClassId || "N/A",
      "Is Interview Taken": registration.isInterviewTaken ? "Yes" : "No",
      "Interview Remarks": registration.interviewRemarks || "N/A",
      "Is Interview Scheduled": registration.isInterviewScheduled
        ? "Yes"
        : "No",
      "Interview Date": registration.interviewDate
        ? registration.interviewDate.split("T")[0]
        : "N/A",
      "Is Assessment Added": registration.isAssessmentAdded ? "Yes" : "No",
      "Is Assessment Marks Added": registration.isAssessmentMarksAdded
        ? "Yes"
        : "No",
      "Is Accepted": registration.isAccepted ? "Yes" : "No",
      "Acceptance Remarks": registration.acceptanceRemarks || "N/A",
      "Has Observation": registration.hasObservation ? "Yes" : "No",
      "Observation Remarks": registration.observationRemarks || "N/A",
      "Should Retake Exam": registration.shouldRetakeExam ? "Yes" : "No",
      "Retake Exam Remarks": registration.retakeExamRemarks || "N/A",
      "Registration Voucher No": registration.registrationVoucherNo || "N/A",
      "Is Paid Registration": registration.isPaidRegistration ? "Yes" : "No",
      "Admission Voucher No": registration.admissionVoucherNo || "N/A",
      "Is Paid Admission": registration.isPaidAdmission ? "Yes" : "No",
      "Is Center Submit": registration.isCenterSubmit ? "Yes" : "No",
      "Center Submission Date": registration.centerSubmissionDate
        ? registration.centerSubmissionDate.split("T")[0]
        : "N/A",
      "Center Updated By": registration.centerUpdatedBy || "N/A",
      "Created On": registration.createdOn
        ? registration.createdOn.split("T")[0]
        : "N/A",
      "Created By": registration.createdBy || "N/A",
      "Country Code": registration.countryCode || "N/A",
      "Country Name": registration.countryName || "N/A",
      "Student Image": registration.studentImage || "N/A",
      "Image Path": registration.imagePath || "N/A",
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registrations");
    XLSX.writeFile(workbook, "RegistrationReport.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    // Add logo
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;
    doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    // Add title
    const title = "Registration Report";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const visibleColumns = columns.filter((col) => !col.omit);
    const bodyData = filteredRegistrations.map((registration, index) => [
      (currentPage - 1) * rowsPerPage + index + 1,
      `${registration.firstName} ${registration.lastName}`,
      registration.code,
      registration.className || "N/A",
      registration.greGorianDOB
        ? registration.greGorianDOB.split("T")[0]
        : "N/A",
      registration.nationality || "N/A",
    ]);

    doc.autoTable({
      head: [visibleColumns.map((col) => col.name)],
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [144, 84, 255],
        textColor: [255, 255, 255],
      },
    });
    doc.save("RegistrationReport.pdf");
  };

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Registration Report</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-2">
              <label className="form-label">
                Center<span className="text-danger fs-9">*</span>
              </label>
              <Controller
                name="centerId"
                control={control}
                rules={{ required: "This field is required." }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={centersData.map((center) => ({
                      value: center.id,
                      label: center.name,
                    }))}
                    isDisabled={savedCenterId !== "0"}
                    onChange={(selectedOption, actionMeta) => {
                      if (actionMeta.action === "clear") {
                        setValue("centerId", null);
                        setValue("yearGroup", { value: "all", label: "All" });
                        setCenterId(null);
                        setYearGroupsData([]);
                        setRegistrationsData([]);
                        setFilteredRegistrations([]);
                      } else {
                        setValue("centerId", selectedOption);
                        setValue("yearGroup", { value: "all", label: "All" });
                        setCenterId(selectedOption.value);
                        fetchYearGroupsByCenterId(selectedOption.value);
                      }
                      trigger("centerId");
                    }}
                    className="react-select-style"
                    classNamePrefix="react-select-style-pref"
                  />
                )}
              />
              {errors.centerId && (
                <small className="text-danger">{errors.centerId.message}</small>
              )}
            </div>
            <div className="col-md-2">
              <label className="form-label">Year Group</label>
              <Controller
                name="yearGroup"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={[
                      { value: "all", label: "All" },
                      ...yearGroupsData.map((yg) => ({
                        value: yg.id,
                        label: yg.name,
                      })),
                    ]}
                    onChange={(selectedOption) => {
                      setValue("yearGroup", selectedOption);
                    }}
                    className="react-select-style"
                    classNamePrefix="react-select-style-pref"
                  />
                )}
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">
                Nationality<span className="text-danger fs-9">*</span>
              </label>
              <Controller
                name="nationality"
                control={control}
                rules={{ required: "This field is required." }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={nationalityOptions}
                    onChange={(selectedOption) => {
                      setValue("nationality", selectedOption);
                      trigger("nationality");
                    }}
                    className="react-select-style"
                    classNamePrefix="react-select-style-pref"
                  />
                )}
              />
              {errors.nationality && (
                <small className="text-danger">
                  {errors.nationality.message}
                </small>
              )}
            </div>
            <div className="col-md-2">
              <label className="form-label">Search by Code</label>
              <input
                type="text"
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label" style={{ visibility: "hidden" }}>
                Action
              </label>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  data-bs-toggle="tooltip"
                  data-bs-custom-class="custom-tooltip"
                  title="Export to Excel"
                  className="btn btn-outline-success px-2 py-1"
                  onClick={exportToExcel}
                >
                  <i className="fs-8 fa fa-file-excel"></i>
                </button>
                <button
                  type="button"
                  data-bs-toggle="tooltip"
                  data-bs-custom-class="custom-tooltip"
                  title="Export to PDF"
                  className="btn btn-outline-danger px-2 py-1"
                  onClick={exportToPDF}
                >
                  <i className="fs-8 fa fa-file-pdf"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-3">
        <div className="card-body">
          <DataTable
            columns={columns.filter((col) => !col.omit)}
            data={filteredRegistrations}
            pagination
            dense
            highlightOnHover={true}
            pointerOnHover={true}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRowsPerPage={(newRowsPerPage) =>
              setRowsPerPage(newRowsPerPage)
            }
            expandableRows
            expandableRowsComponent={ExpandedComponent}
          />
        </div>
      </div>
    </>
  );
}

export default RegistrationReport;
